// GA4 provider wrapper
export function track(name: string, props: Record<string, unknown> = {}) {
  try {
    const win = window as any
    if (typeof win.gtag === 'function') {
      win.gtag('event', name, props)
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('ga4.track error', err)
  }
}
